import { useContext } from 'react';

import { TranslatorContext } from 'translation';
import { LANGUAGE_MAP } from '$shared/constants/languages';

export const useCurrentLang = () => {
  const key = useContext(TranslatorContext).lang;

  return {
    key,
    label: `${LANGUAGE_MAP[key]} (${key.toUpperCase()})`
  }
};
